export enum TransformationType {
    Multiplier = 'multiplier',
    Percent = 'percent',
    Round = 'round',
}
